import { Link } from 'react-router-dom';
import { Box, Card, CardActionArea, SxProps, Theme } from '@mui/material';

import { Body } from './components/Body';
import { Actions } from './components/Actions';
import { ToolboxItemProps } from './types';
import { getCreateButtonTestId } from './utils';

const styles: SxProps<Theme> = {
  p: 3,
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  alignItems: 'stretch',
  borderBlock: 'primary',
};

export const Toolbox = (props: ToolboxItemProps) => {
  const { type, title, description, linkToCreate, linkToEdit, linkToDetails, loading } = props;
  const viewType = props.viewType || 'default';

  return (
    <Card variant='outlined' sx={{ height: '100%' }} elevation={0}>
      {viewType === 'link' ? (
        <CardActionArea
          disableRipple={true}
          component={Link}
          to={(linkToCreate || linkToEdit || linkToDetails)!}
          sx={styles}
          data-testid={getCreateButtonTestId(type)}
        >
          <Body title={title} type={type} description={description} />
        </CardActionArea>
      ) : (
        <Box sx={styles}>
          <Body title={title} type={type} description={description} />
          <Actions
            type={type}
            linkToCreate={linkToCreate}
            linkToEdit={linkToEdit}
            linkToDetails={linkToDetails}
            loading={loading}
          />
        </Box>
      )}
    </Card>
  );
};
